import { PHONE_TYPES, SOCIAL_MEDIA_TYPES } from '../../../constants/admin/settings';
import { capitalize, pick, filter, find, map, uniqBy } from 'lodash';
import {
    ROLE_NONE,
    ROLE_TYPE_ORGANIZATION,
    ROLE_TYPE_PARTNER,
    ROLE_TYPE_ARTIST
} from '../../../constants/authentication/permissions';
import { transformContractText } from './contracts';
import { relatedToFromFunction } from './permissions';
import { v4 as uuidv4 } from 'uuid';
import { bufferArrayToUtf8 } from '../../../lib/string.utils';

// DATA SELECTORS
export const phoneTypeOptions = PHONE_TYPES.map(pt => ({
    value: pt,
    label: capitalize(pt)
}));

export const socialMediaOptions = SOCIAL_MEDIA_TYPES.map(sm => ({
    value: sm,
    label: capitalize(sm)
}));

// API/STATE SELECTORS
const _filterTypeRoles = (roles, type) => filter(roles, x => relatedToFromFunction(x.function) === type);

export const apiDataToState = data => {
    data.roles = data.roles || [];
    data.organizationIds = map(_filterTypeRoles(data.roles, ROLE_TYPE_ORGANIZATION), x => x.orgId);
    data.partnerIds = map(_filterTypeRoles(data.roles, ROLE_TYPE_PARTNER), x => x.partnerId);
    data.artistIds = map(_filterTypeRoles(data.roles, ROLE_TYPE_ARTIST), x => x.artistId);
    data.phones = (data.phones || []).concat([{ k: PHONE_TYPES[0], v: '' }]);
    data.socialMedia = (data.socialMedia || []).concat([{ k: SOCIAL_MEDIA_TYPES[0], v: '' }]);
    data.image = bufferArrayToUtf8((data.image && data.image.data) || []);
    data.roles = filter(data.roles, x => x.name !== ROLE_NONE);
    data.note = data.note || '';
    return data;
};

export const stateToApiData = data => {
    data.roles = filter(data.roles || [], x => x.NAME !== ROLE_NONE);
    (data.organizationIds || []).forEach(
        orgId =>
            (data.roles = [{ id: uuidv4(), orgId, function: ROLE_TYPE_ORGANIZATION, name: ROLE_NONE }, ...data.roles])
    );
    (data.partnerIds || []).forEach(
        partnerId =>
            (data.roles = [{ id: uuidv4(), partnerId, function: ROLE_TYPE_PARTNER, name: ROLE_NONE }, ...data.roles])
    );
    (data.artistIds || []).forEach(
        artistId =>
            (data.roles = [{ id: uuidv4(), artistId, function: ROLE_TYPE_ARTIST, name: ROLE_NONE }, ...data.roles])
    );
    data.roles = uniqBy(
        data.roles,
        r =>
            `${r.function || ''}_${r.name || ''}_${r.orgId || ''}_${r.artistId || ''}_${
                r.eventId || ''
            }_${r.partnerId || ''}`
    );
    const bodyData = {
        ...data,
        phones: filter(data.phones || [], p => p.v),
        socialMedia: filter(data.socialMedia || [], sm => sm.v),
        roles: data.roles.map(r =>
            pick(r, [
                'id',
                'artistId',
                'name',
                'function',
                'partnerId',
                'eventId',
                'orgId',
                'accessToClearanceContracts',
                'accessToPerformanceContracts'
            ])
        ),
        image: data.image || ''
    };

    return pick(bodyData, ['fullName', 'roles', 'email', 'note', 'website', 'phones', 'socialMedia', 'image']);
};

export const parseModalContract = async props => {
    const templateClearing = props.data.templateClearing;
    const clearing = [...props.performanceData.clearing].map(c => ({
        ...c,
        live: templateClearing.live || c.live,
        nonLinear: templateClearing.nonLinear || c.nonLinear,
        useUntil: templateClearing.useUntil || c.useUntil,
        comments: templateClearing.comments || c.comments
    }));
    const text = transformContractText(props.data.data, props);
    const stage = find(props.stages, s => s.value === props.performanceData.stageIdentifier) || {};

    return {
        ...props.data,
        eventId: props.eventId,
        artistId: props.artistId,
        organizationId: props.organizationId,
        clearing,
        performances: [
            JSON.stringify({
                name: (stage.label || '').split(' - ').slice(1).join(''),
                id: props.performanceId
            })
        ],
        data: text
    };
};
